module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_j_normal.d4476067.png";